import styled from 'styled-components';
import { Popover as PopoverAntd } from 'antd';
import color from '../../configs/color';

const Popover = styled(PopoverAntd)`
  padding: 2px 0;
`;

export default Popover;

export const MenuItem = styled.div`
  padding: 12px 18px;
  display: flex;
  align-items: center;
  color: ${color.black2};
  font-size: 16px;
  cursor: pointer;
  border-bottom: 1px solid ${color.grey2};
  &:hover {
    background-color: ${color.grey4};
  }
  &.danger {
    color: ${color.red1};
    svg {
      color: ${color.red1};
    }
  }
  &.success {
    color: ${color.green1};
    svg {
      color: ${color.green1};
    }
  }

  &.last {
    border-bottom: unset;
  }

  .component_action_menu_popover_icon {
    margin-right: 12px;
  }

  min-width: ${(props) => {
    return props.minWidth ? `${props.minWidth}px` : '177px';
  }};
`;
